import { bindEvents, easing, mq } from '../helpers';

import AnimationController from './animation';
import ResizeController from './resize';

let wrapper = null;

class ScrollController {

	constructor() {
		this.scrolls = [];

		this.height = 0;

		this.rendering = true;

		this.controllers = {
			animation: null,
			resize: null
		};

		this.ease = {
			duration: 60,
			function: 'easeOutQuint',
			from: 0,
			frame: 0
		};

		this.flags = {
			isDesktop: this.isDesktop
		};

		this.actual = 0;
		this.chunk = 0;
		this.delta = 0;
		this.direction = 0;
		this.position = 0;

		this.jump = false;

		// bind events to scope
		this.events = bindEvents(this);

		// mosey
		this.addEventListeners();
	}

	get wrapper() {
		return wrapper;
	}

	set wrapper(el) {
		wrapper = el;
		return true;
	}

	measureContentHeight() {
		this.height = this.wrapper.offsetHeight;
	}

	renderContentHeight() {
		document.body.style.height = `${this.height}px`;
	}

	updateHeight() {
		this.measureContentHeight();
		this.renderContentHeight();
	}

	updateDirection(top) {
		if (top > this.position) {
			this.direction = 1;
		} else if (top === this.position) {
			this.direction = 0;
		} else {
			this.direction = -1;
		}
	}

	updateScrollTo() {
		this.ease.from = this.position;
		this.ease.frame = this.ease.duration;
	}

	updateJumpTo() {
		this.ease.from = this.actual;
		this.ease.frame = 1;
	}

	updatePosition() {
		if (this.flags.isDesktop) {
			const current = Math.round(this.ease.from + easing[this.ease.function](this.ease.duration - this.ease.frame, 0, this.actual - this.ease.from, this.ease.duration));
			this.position = current;
		} else {
			this.position = this.actual;
		}
	}

	update() {
		const top = window.scrollY;

		this.chunk = Math.abs(top - this.position);

		this.updateDirection(top);

		this.delta = this.chunk * this.direction;

		if (top !== this.actual) {
			this.actual = top;
			if (this.jump) {
				this.jump = false;
				this.updateJumpTo();
			} else {
				this.updateScrollTo();
			}
		}

		if (this.ease.frame > 0) {
			--this.ease.frame;
			this.updatePosition();
			const {
				position,
				actual,
				chunk,
				delta,
				direction
			} = this;
			const data = {
				position,
				actual,
				chunk,
				delta,
				direction
			};

			for (let i = 0, l = this.scrolls.length; i < l; ++i) {
				const scroll = this.scrolls[i];
				if (scroll && scroll.update(data)) scroll.updated = true;
			}
			return true;
		}
	}

	render() {
		if (this.rendering && this.wrapper) this.wrapper.style.transform = `translate3d(0,-${this.position}px,0)`;
		document.body.classList[this.actual <= 0 ? 'add' : 'remove']('is-top');

		for (let i = 0, l = this.scrolls.length; i < l; ++i) {
			const scroll = this.scrolls[i];
			if (scroll && scroll.updated) {
				scroll.updated = false;
				scroll.render();
			}
		}
	}

	start() {
		this.controllers.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		});
	}

	pause() {
		AnimationController.clear(this.controllers.animation);
	}

	scrollTo(top, jump) {
		this.jump = jump;
		window.scroll(false, top);
	}

	// subscribers set and clear

	set(obj) {
		obj.updated = false;
		this.scrolls.push(obj);
		return this.scrolls.length - 1;
	}

	clear(index) {
		this.scrolls[index] = null;
	}

	// lock / unlock scrolling

	lockScroll() {
		document.documentElement.classList.add('is-no-scroll');
	}

	unlockScroll() {
		document.documentElement.classList.remove('is-no-scroll');
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: () => true,
			render: () => { this.events._onWindowResize(); }
		});

		this.measureResize();
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
	}

	measure() {
		this.viewport = window.innerHeight;
		if (this.wrapper) this.updateHeight();
	}

	measureResize() {
		this.flags.isDesktop = this.isDesktop;
		this.measure();
	}

	// listener methods

	_onWindowResize() {
		this.measureResize();
	}

	// reset stored values (delta, position, etc)

	reset() {
		this.actual = 0;
		this.chunk = 0;
		this.delta = 0;
		this.direction = 0;
		this.position = 0;

		this.ease.from = this.position;
		this.ease.frame = 1;

		this.update();
		this.render();
	}

	//

	get isDesktop() {
		// const isSafari = (navigator.userAgent.toLowerCase().indexOf('safari') !== -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1);
		// return mq('medium') && !isSafari;

		return mq('medium');
	}

}

export default new ScrollController();
